import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { AuthenticationService } from './service-authen/authentication.service';
import { SocketService } from '../socket.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  hide = true;
  error_msg: string;
  disabled_button: boolean = true
  login_by_pass: boolean = false
  login_by_oneid: boolean = false

  announcementAPI = `${environment.apiUrl}/announcement/check`;
  // Forms
  formLogin: FormGroup;
  constructor(
    private builder: FormBuilder,
    private router: Router,
    private http: HttpClient,
    private authenticationService: AuthenticationService,
    private socket: SocketService,
    public _snackBar: MatSnackBar,
    public dialog: MatDialog,
  ) {
    this.formLogin = this.builder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    });
  }

  ngOnInit() {
    localStorage.clear();
    this.socket.listen('usermoo').subscribe(data => {
      console.log('connect socket', data);
    })
    this.check_announccment()
  }

  toggle_btn_password() {
    return this.hide = !this.hide
  }

  open_loginByPass() {
    this.login_by_pass = true
    this.disabled_button = false
  }

  open_loginOne() {
    this.login_by_oneid = true
    this.disabled_button = false
  }

  login(): void {
    this.formLogin.get('username').markAsTouched();
    this.formLogin.get('password').markAsTouched();
    this.authenticationService.login(this.formLogin.value).subscribe(responseLogin => {
      // console.log(responseLogin);
      const hospitalAPI = `${environment.apiUrl}/consent?hospital_id=${responseLogin['token']['hospital_id']}`;
      this.http.get(hospitalAPI).subscribe(res => {
        // console.log(res['message']);
        if (res['message'] == "true") {
          if (responseLogin['token']['hospital'] == '') {
            // this.add_hospital = true
            return
          }
          else if (responseLogin['token']['status'] == 'wait') {
            // this.add_hospital_success = true
            return
          }
          else if (responseLogin['token']['status'] == 'approve' && responseLogin['token']['role'] == 'viewer') {
            this.authenticationService.setAuthorizationToken(responseLogin['token']);
            this.router.navigate(['/main/history']);
          }
          else if (responseLogin['token']['status'] == 'approve') {
            this.authenticationService.setAuthorizationToken(responseLogin['token']);
            this.router.navigate(['/selete-hospital']);
          }
        } else {
          this.authenticationService.setAuthorizationToken(responseLogin['token']);
          this.dialog_consent()
        }
      })
    },
      error => {
        console.log(error.error.message);
        this._snackBar.open(error.error.message, 'Done', {
          duration: 3000,
        });
      });
    // });
  }


  loginOne(): void {
    this.formLogin.get('username').markAsTouched();
    this.formLogin.get('password').markAsTouched();
    this.authenticationService.loginOne(this.formLogin.value).subscribe(responseLogin => {
      // console.log(responseLogin);
      const hospitalAPI = `${environment.apiUrl}/consent?hospital_id=${responseLogin['token']['hospital_id']}`;
      this.http.get(hospitalAPI).subscribe(res => {
        // console.log(res['message']);
        if (res['message'] == "true") {
          if (responseLogin['token']['hospital'] == '') {
            // this.add_hospital = true
            return
          }
          else if (responseLogin['token']['status'] == 'wait') {
            // this.add_hospital_success = true
            return
          }
          else if (responseLogin['token']['status'] == 'approve' && responseLogin['token']['role'] == 'viewer') {
            this.authenticationService.setAuthorizationToken(responseLogin['token']);
            this.router.navigate(['/main/history']);
          }
          else if (responseLogin['token']['status'] == 'approve') {
            this.authenticationService.setAuthorizationToken(responseLogin['token']);
            this.router.navigate(['/selete-hospital']);
          }
        } else {
          this.authenticationService.setAuthorizationToken(responseLogin['token']);
          this.dialog_consent()
        }
      })
    },
      error => {
        this._snackBar.open(error.error.message, 'Done', {
          duration: 3000,
        });
        if (error.status == 500) {
          this._snackBar.open('Login Oneid fail!', 'Done', {
            duration: 3000,
          });
        }
      });
    // });
  }

  redirectCXR3(){
    window.open("https://1ls.manageai.co.th/login", "_blank");
  }

  dialog_forget_password() {
    const dialogRef = this.dialog.open(dialog_forget, {
      width: '710px',
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    })
  }

  dialog_notify() {
    const dialogRef = this.dialog.open(dialog_notify, {
      width: '710px',
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      localStorage.removeItem('message')
    })
  }

  dialog_consent() {
    const dialogRef = this.dialog.open(dialog_consent, {
      // width: '710px',
      autoFocus: false,
      maxHeight: '90vh' //you can adjust the value as per your view
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      localStorage.removeItem('message')
    })
  }

  check_announccment() {
    this.http.get(this.announcementAPI).subscribe(res => {
      console.log(res);
      if (res['message']['inUse'] == true) {
        localStorage.setItem('message', res['message']['message'])
        this.dialog_notify()
      }
    })
  }

  register() {
    console.log("register");
  }

}

@Component({
  selector: 'dialog_forget',
  templateUrl: 'dialog-forget.html',
  styleUrls: ['login.component.scss']
})
export class dialog_forget implements OnInit {
  // ceate form add
  formForget: FormGroup;
  message = "Forget Password Sussecc!"
  action = "Done"
  // api
  headers = new HttpHeaders().set('Content-Type', 'application/json').set('Accept', 'application/json').set('Authorization', `${localStorage.getItem('access_token')}`);
  httpOptions = {
    headers: this.headers
  };

  forgetApi = `${environment.apiUrl}/history`;

  constructor(
    public dialogRef: MatDialogRef<dialog_forget>,
    private http: HttpClient,
    // private route: Router,
    public formBuilder: FormBuilder,
    public _snackBar: MatSnackBar
  ) {
    this.formForget_pass()
  }

  ngOnInit() {

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  private formForget_pass() {
    this.formForget = this.formBuilder.group({
      account_id: [''],
      username: ['', Validators.required],
      email: ['', [Validators.email, Validators.required]],
    })
  }

  forget_password() {
    if (this.formForget.invalid) return
    this.http.put(`${this.forgetApi}`, this.httpOptions).subscribe(data => {
      // console.log('Delete Success', data);
      this.onNoClick()
      this._snackBar.open(this.message, this.action, {
        duration: 5000,
      });
    }, error => {
      this._snackBar.open("Forget Password fail!", this.action, {
        duration: 5000,
      });
      console.log('Error: ', error.error.message);
    });
  }

}

@Component({
  selector: 'dialog_notify',
  templateUrl: 'dialog_notify.html',
  styleUrls: ['login.component.scss']
})
export class dialog_notify implements OnInit {
  message = localStorage.getItem('message')
  // api
  headers = new HttpHeaders().set('Content-Type', 'application/json').set('Accept', 'application/json').set('Authorization', `${localStorage.getItem('access_token')}`);
  httpOptions = {
    headers: this.headers
  };

  constructor(
    public dialogRef: MatDialogRef<dialog_notify>,
  ) {

  }

  ngOnInit() {
    this.message
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}

@Component({
  selector: 'dialog_consent',
  templateUrl: 'dialog_consent.html',
  styleUrls: ['login.component.scss']
})
export class dialog_consent implements OnInit {
  status = localStorage.getItem('status')
  role = localStorage.getItem('role')
  hospital_id = localStorage.getItem('hospital_id')
  // Forms
  agree = new FormControl('', [Validators.required]);
  // api
  headers = new HttpHeaders().set('Content-Type', 'application/json').set('Accept', 'application/json').set('Authorization', `${localStorage.getItem('access_token')}`);
  httpOptions = {
    headers: this.headers
  };

  constructor(
    public dialogRef: MatDialogRef<dialog_consent>,
    private http: HttpClient,
    private router: Router,
  ) {
  }

  ngOnInit() {

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  agree_consent() {
    const consentAPI = `${environment.apiUrl}/consent`;
    // console.log('agree');
    this.http.post(consentAPI, { hospital_id: this.hospital_id, action: this.agree.value }, this.httpOptions).subscribe(res => {
      console.log(res);
      if (this.status == 'approve' && this.role == 'viewer') {
        this.router.navigate(['/main/history']);
      }
      else if ((this.status == 'approve')) {
        this.router.navigate(['/selete-hospital']);
      } else {
        return
      }
      this.onNoClick()
      // this._snackBar.open('Add user success.', 'Done', {
      //   duration: 3000,
      // });
    }, err => {
      console.log(err.error.message);
      // if (err.error.message == 'duplicate username') {
      //   this._snackBar.open('duplicate username.', 'Done', {
      //     duration: 5000,
      //   });
    })
  }

}
